/** @jsx jsx */
import {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {jsx, css} from '@emotion/react'

import {isChrome} from '../../../util/userAgent'
import {isNewTabPage} from '../../../util/url'
import {
    chromeProtectionExtensionLink,
    firefoxProtectionInlineInstallLink,
    chromeNewTabStoreLink,
    firefoxNewTabStoreLink,
} from '../../../util/extensionStoreLinks'
import {logDplWithExtensionParams, EVENTS} from '../../../util/dpl'
import {colors} from '../../../constants'

const buttonStyles = css`
    font-size: 1rem;
    font-family: 'Proxima Nova', sans-serif;
    border-radius: 4px;
    display: inline-block;
    font-family: inherit;
    letter-spacing: 0.02rem;
    line-height: 1.2;
    transition: background-color 0.3s cubic-bezier(0, 0.4, 0.74, 0.63);
    background-color: ${colors.brandBlue};
    border: none;
    color: ${colors.whisperLight};
    padding: 0.75rem 1.25rem;
    &:hover {
        cursor: pointer;
        background-color: ${colors.brandBlueLight};
    }
`

const Button = ({
    text,
    experiment,
    onClick,
    ctaType,
    ariaLabel,
    tabIndex = '0',
    languageCode = 'en',
    overrideStyles = ``,
}) => {
    const [btnText, setBtnText] = useState(text)
    const [installLink, setInstallLink] = useState(firefoxProtectionInlineInstallLink)

    const setStoreLink = () => {
        if (isChrome()) {
            if (isNewTabPage()) {
                setInstallLink(chromeNewTabStoreLink)
            } else {
                setInstallLink(chromeProtectionExtensionLink(languageCode))
            }
        } else {
            // firefox
            if (isNewTabPage()) {
                setInstallLink(firefoxNewTabStoreLink)
            } else {
                setInstallLink(firefoxProtectionInlineInstallLink)
            }
        }
    }

    useEffect(() => {
        if (isChrome()) {
            setBtnText(text.replace(`{}`, `Chrome`))
        } else {
            setBtnText(text.replace(`{}`, `Firefox`))
        }
        setStoreLink()
    }, [setBtnText, setInstallLink, setStoreLink, text])

    const onBtnClick = () => {
        logDplWithExtensionParams(
            EVENTS.StartpageClick,
            {
                type: ctaType,
                experiment,
            },
            ['extSgc'],
        ).then(() => {
            window.location.href = installLink
        })
    }

    return (
        <button
            className="conversion-button"
            onClick={onClick || onBtnClick}
            aria-label={ariaLabel}
            css={css`
                ${buttonStyles}
                ${overrideStyles}
            `}
            tabIndex={tabIndex}
        >
            {btnText}
        </button>
    )
}

Button.propTypes = {
    experiment: PropTypes.string,
    onClick: PropTypes.func,
    ctaType: PropTypes.string,
    text: PropTypes.string,
    ariaLabel: PropTypes.string,
    overrideStyles: PropTypes.any,
}

Button.defaultProps = {
    experiment: `sp-415`,
    ctaType: `cta-1`,
    text: `Add to Firefox`,
    ariaLabel: `Add to Firefox`,
    overrideStyles: ``,
}

export default Button
